import {useEffect, useRef, useState} from "react";
import axios from "axios";
import Pagination from "../../elements/Pagination";
import Modal from "../../elements/Modal";
import { formValid, resetFieldsErrors } from '../../../functions/form';
import { isJsonString } from "../../../functions/functions";
import { setError } from "../../../slices/error/ErrorSlice";
import { useDispatch } from "react-redux";

export default function Importer() {
    const dispatch = useDispatch();

    const[list, setList] = useState([]);
    const[form, setForm] = useState({
        inn: '',
        name: '',
        address: '',
        region: ''
    })
    const formRefs = useRef({
        inn: useRef(null),
        name: useRef(null),
        address: useRef(null),
        region: useRef(null)
    });
    const[params, setParams] = useState({
        name: '',
        inn: ''
    });
    const[pagination, setPagination] = useState({
        currentPage: 1,
        pagesCount: 0
    });
    const[modalShow, setModalShow] = useState(false);
    const[modalDelShow, setModalDelShow] = useState(false);
    const[editId, setEditId] = useState(null);
    const[delId, setDelId] = useState(null);
    const[nameDel, setNameDel] = useState(null);

    useEffect(() => {
        getList();
    }, [pagination.currentPage]);

    useEffect(() => {
        let timeout = setTimeout(() => {
            getList();
        }, 1000)

        return () => {
            clearTimeout(timeout);
        };
    }, [params]);

    function modalShowToggler() {
        setModalShow(!modalShow);
    }

    function closeModalEntity() {
        setModalShow(!modalShow);
        resetForm();
        resetFieldsErrors(formRefs.current);
        setEditId(null);
    }

    function resetForm() {
        setForm({
            inn: '',
            name: '',
            address: '',
            region: ''
        })
    }

    function openModalDelHandler(e) {
        setDelId(Number(e.currentTarget.getAttribute('iid')));
        setNameDel(e.currentTarget.previousSibling.previousSibling.previousSibling.previousSibling.innerHTML)
        setModalDelShow(!modalDelShow);
    }

    function closeModalDelHandler() {
        setModalDelShow(!modalDelShow);
        setDelId(null);
        setNameDel(null);
    }

    function changeParamsHandler(e) {
        let fieldName = e.target.name;
        let value = e.target.value;

        setParams({...params, [fieldName]: value});
    }

    function setCurrentPage(page) {
        setPagination({...pagination, currentPage: page});
    }

    function getList() {
        axios.get('/api/importer-list', {params: {...params, page: pagination.currentPage}})
            .then(res => {
                setList(res.data);
                let headers = {
                    currentPage:    Number(res.headers['x-pagination-current-page']),
                    pagesCount:     Number(res.headers['x-pagination-pages-count'])
                }
                setPagination(headers);
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    function getItemHandler(e) {
        const id = e.currentTarget.getAttribute('iid');
        setEditId(id);

        axios.get(`/api/importer/${id}`)
            .then(res => {
                setForm(Object.assign(form, res.data));
                modalShowToggler();
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    function changeHandler(e) {
        let fieldName = e.target.name;
        let value = e.target.value;

        setForm({...form, [fieldName]: value});
    }

    function createHandler() {
        axios.post('/api/importer/create', form)
            .then(res => {
                getList();
                closeModalEntity();
            })
            .catch((e) => {
                if(isJsonString(e.response.data.detail)) {
                    let objErr = JSON.parse(e.response.data.detail);
                    formValid(formRefs.current, objErr);
                } else {
                    dispatch(setError(e.response.data));
                }
            })
    }

    function editHandler() {
        axios.post(`/api/importer/${editId}/edit`, form)
            .then(res => {
                console.log('exporter was updated')
                closeModalEntity();
                getList();
            })
            .catch(e => {
                if(isJsonString(e.response.data.detail)) {
                    let objErr = JSON.parse(e.response.data.detail);
                    formValid(formRefs.current, objErr);
                } else {
                    dispatch(setError(e.response.data));
                }
            })
    }

    function delHandler() {
        axios.delete(`/api/importer/${delId}/del`)
            .then(res => {
                closeModalDelHandler();
                getList();
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    let rows = list.map(item =>
        <tr key={item.id}>
            <td>{item.code}</td>
            <td>{item.inn}</td>
            <td>{item.name}</td>
            <td>{item.address}</td>
            <td>{item.region}</td>
            <td iid={item.id} onClick={getItemHandler}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                     className="bi bi-pencil hover" viewBox="0 0 16 16">
                    <path
                        d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                </svg>
            </td>
            <td iid={item.id} onClick={openModalDelHandler}>
                <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-trash hover red" fill="currentColor"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                    <path
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                </svg>
            </td>
        </tr>
    )

    return (
        <>
            <Modal
                header={editId ? 'Редактирование' : 'Добавить импортера'}
                show={modalShow}
                closeHandler={closeModalEntity}
            >
                <div className="mb-3 row">
                    <label htmlFor="input-name" className="col-sm-3 col-form-label">Наименование</label>
                    <div className="col-sm-9">
                        <input type="text" name='name' className="form-control" id="input-name"
                               ref={formRefs.current.name}
                               onChange={changeHandler} value={form.name}
                        />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="input-inn" className="col-sm-3 col-form-label">Инн</label>
                    <div className="col-sm-9">
                        <input type="text" name='inn' className="form-control" id="input-inn" ref={formRefs.current.inn}
                               onChange={changeHandler} value={form.inn}
                        />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="input-address" className="col-sm-3 col-form-label">Адрес</label>
                    <div className="col-sm-9">
                        <input type="text" name='address' className="form-control" id="input-address"
                               ref={formRefs.current.address}
                               onChange={changeHandler} value={form.address}
                        />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="input-region" className="col-sm-3 col-form-label">Регион</label>
                    <div className="col-sm-9">
                        <input type="text" name='region' className="form-control" id="input-region"
                               ref={formRefs.current.region}
                               onChange={changeHandler} value={form.region}
                        />
                    </div>
                </div>

                <div className='modal-footer-custom d-grid gap-2 d-md-flex justify-content-md-end'>
                    <input type='button' className='btn mb-0 btn-success margin-botom'
                           onClick={editId ? editHandler : createHandler}
                           value="Сохранить"/>
                    <input type='button' className='btn mb-0 btn-danger margin-botom' onClick={closeModalEntity}
                           value='Отмена'/>
                </div>
            </Modal>

            <Modal
                header='Удалить клиента'
                show={modalDelShow}
                closeHandler={closeModalDelHandler}
            >
                <div className="float-none">{nameDel}</div>
                <div className='modal-footer-custom d-grid gap-2 d-md-flex justify-content-md-end'>
                    <input type='button' className='btn mb-0 btn-success margin-botom'
                           onClick={delHandler}
                           value='Да'/>
                    <input type='button' className='btn mb-0 btn-danger margin-botom' onClick={closeModalDelHandler}
                           value='Нет'/>
                </div>
            </Modal>

            <h1>Импортеры</h1>

            <input type='button' className='btn btn-primary margin-botom' onClick={modalShowToggler} value='Добавить'/>

            <table className="table table-striped table-bordered">
                <thead>
                <tr>
                    <th scope="col">Код</th>
                    <th scope="col">ИНН</th>
                    <th scope="col">Наименование</th>
                    <th scope="col">Адрес</th>
                    <th scope="col">Регион</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
                <tr>
                    <td></td>
                    <td><input onChange={changeParamsHandler} type="text" name='inn' className="form-control" placeholder='Поиск'/></td>
                    <td><input onChange={changeParamsHandler} type="text" name='name' className="form-control" placeholder='Поиск'/></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                </thead>
                <tbody>
                    {rows}
                </tbody>
            </table>

            <Pagination pagesCount={pagination.pagesCount} currentPage={pagination.currentPage}
                        setPageHandler={setCurrentPage}/>
        </>
    )
}